// H/Mitra milestones are fixed by the backend legacy follow-up workflow.

export const getSampleTypeFamily = (sampleTypeCode) => {
  const code = String(sampleTypeCode || "").trim().toUpperCase();
  const match = code.match(/^([A-Z]+)\d+$/);
  if (match) {
    return match[1];
  }
  return code;
};
